import React from 'react';
import PropTypes from 'prop-types';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';

/**
 * Slide-over right side modal drawer (matching Live Transactions inspector style)
 */
export default function BasicModal({ isOpen, toggleOpen, children, styles, width }) {
  const { border, borderRadius, position, top, left, transform, maxHeight, ...filteredStyles } = styles || {};

  return (
    <Drawer
      anchor="right"
      open={Boolean(isOpen)}
      onClose={toggleOpen}
      PaperProps={{
        sx: {
          width: width || { xs: '100%', sm: 480, md: 560 },
          maxWidth: '100vw',
          height: '100%',
          bgcolor: 'background.paper',
          p: { xs: 2.5, sm: 3.5 },
          overflowY: 'auto',
          boxShadow: '-8px 0 32px rgba(0, 0, 0, 0.12)',
          borderLeft: (theme) => `1px solid ${theme.palette.divider}`,
          ...filteredStyles,
        },
      }}
    >
      <Box sx={{ minHeight: '100%', display: 'flex', flexDirection: 'column' }}>
        {children}
      </Box>
    </Drawer>
  );
}

BasicModal.propTypes = {
  isOpen: PropTypes.bool,
  toggleOpen: PropTypes.func,
  children: PropTypes.node,
  styles: PropTypes.object,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]),
};
